import React, { useState } from 'react'
import { X } from "@phosphor-icons/react";
import Img from "../../../Assets/gallery.png";

export default function ManageGuestsImageView(props) {

    // console.log("Modal Data : ",props.modalData)
    
    const closeModal = ()=>{
        props.setImageOpen(false);
    }

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [fade, setFade] = useState(false);

    const images = props?.modalData?.img || [];

    const handlePrev = () => {
        setFade(true);
        setTimeout(() => {
            setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
            setFade(false);
        }, 200); // Match with fade duration
    };

    const handleNext = () => {
        setFade(true);
        setTimeout(() => {
            setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
            setFade(false);
        }, 200);
    };

    // console.log("data : ",props.modalData)

 
    return (
    
    <>
        {props.imageOpen && 
            <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
                <div className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-full md:w-[70%] lg:w-[50%]" style={{width:"90%",height :"90%"}}>

                    {/* Header */}
                    <div className="flex items-center justify-between">
                        <h4> </h4>
                        <button
                            className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                            type="button"
                            onClick = {()=>closeModal()}
                        >
                            <X weight="bold" size={18} />
                        </button>
                    </div>

 
                    {/* Image Disply */}
                    <div className="relative w-full h-[70vh] flex items-center justify-center">
                        {/* Conditional Title */}
                        {images.length > 0 && (
                            <div className="absolute bottom-[-20px] text-xl font-semibold bg-white px-4 py-1 rounded shadow">
                                {currentImageIndex === 0 ? 'Front' : currentImageIndex === 1 ? 'Back' : ''}
                            </div>
                        )}

                        {/* Image Rendering */}
                        {images.length > 0 ? (
                            <img
                                src={images[currentImageIndex]}
                                alt={`Image ${currentImageIndex + 1}`}
                                className={`object-contain w-full h-full max-h-[70vh] rounded-md transition-opacity duration-300 ${fade ? 'opacity-0' : 'opacity-100'}`}
                            />
                        ) : (
                            <img
                                src={Img}
                                alt="Fallback"
                                className="object-contain w-full h-full max-h-[70vh] rounded-md"
                            />
                        )}

                        {/* Prev & Next Buttons */}
                        {images.length > 1 && (
                            <>
                                <button
                                    onClick={handlePrev}
                                    className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-100"
                                >
                                    ◀
                                </button>

                                <button
                                    onClick={handleNext}
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-100"
                                >
                                    ▶
                                </button>
                            </>
                        )}
                    </div>


                    {/* Guest Details */}
                    <div className="">
                        <h2 className="font-bold">{props?.modalData?.name || "Name"}</h2>
                        <h4>
                            <span className='font-semibold'>
                                Phone : 
                            </span>
                            +{props?.modalData?.phone || "Contact"}
                        </h4>
                        <h4>
                            <span className='font-semibold pe-2'>
                                Email : 
                            </span>
                            {props?.modalData?.email || "Email"}
                        </h4>
                        <h4>
                            <span className='font-semibold pe-2'>
                                Address : 
                            </span>
                            {props?.modalData?.address || "Address"}
                        </h4>
                    </div>
                </div>
            </div>
        }
    </>
  )
}
